export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq5_sell.fdaa631f.mp3";